import React from 'react';

const useMediaQuery = (query: string) => {
  const [match, setMatch] = React.useState(null);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    setMatch(mediaQuery.matches);
    const handler = () => setMatch(!!mediaQuery.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, [query]);

  return match;
};

export default useMediaQuery;
